
import React, { useReducer } from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

import NuDrop  from "components/nubox/NuDrop";
import NuInputEdit from 'components/nubox/NuInputEdit';
import ForSwitch from "components/ForSwitch"
import NuLoading from 'components/nubox/NuLoading';

import AsisModal from "views/_box/AsisModal";
import ModalSorteo from "./ModalSorteo";

import { withRouterJim } from "router/withRouterJim";

import config from "assets/img/config.png";

import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1'},
]


const initialForm = {
  idd:0,
  ope:'n',
  mitris:'P'
};

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class Asistencia2 extends React.Component {
  modalRef = React.createRef();//create ref
  modalSorteoRef = React.createRef();//create ref

  state = {
    isloaging:false,
    modalImagen: false,
    id_asisfe:0,
    fecha:'',
    form: Object.assign({}, initialForm),
    form1: {},

    dataList: [],/* lista  */
    options: [  {value:'P', label:'P'},
                {value:'R', label:'R'},
                {value:'L', label:'L'},
                {value:'F', label:'F'},
              ]
    
  };
   //---------------- CONTEXT API ------------------
    //const store = useStore();
    

  //---------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({dataList:[]});
    

    this.cargar_form();
    this.cargar_data();
    
    const date = new Date();
    const defaultValue = date.toLocaleDateString('en-CA');

    let id_asisfe = this.props.params.id;
    console.log(id_asisfe);
    this.setState({ id_asisfe: id_asisfe, 
                    fecha: defaultValue });
    
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  handleChangeForm1 = (e) => {
    //requerimos la prop name='?' en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){

      let res = e.target.checked? 1:0;        
      this.setState({
        form1:{
          ...this.state.form1,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form1: {
          ...this.state.form1,
          [e.target.name]: e.target.value,
        },
      });
    }
  };

  //-------------- cambiamos valor en la tabla
  handleCellChange=(index, columnId, value)=>{
    const newData = [...this.state.dataList];
    newData[index][columnId] = value;
    
    
    //console.log(newData);
    //setData({  data: newData    });
    this.setState({ datalist: newData });
  }
  //------------------------------------------
  /*calcular_totales=(newData, index)=>{
    //const count = newData.filter(item =>  item.Pocu === "Da" && item.Nume === "Contabilitate").length
    let n_asis =0;
    let n_faltas =0;
    let n_lic =0;

    for(let i=0; i< 50; i++){
      let columnId= "a"+i.toString();
      let value = newData[index][columnId];
      if( value.toUpperCase() === 'P'){ n_asis ++; }
      if( value.toUpperCase() === ''){ n_faltas ++; }
      if( value.toUpperCase() === 'L'){ n_lic ++; }
    }
    newData[index]["n_asis"] = n_asis;
    newData[index]["n_faltas"] = n_asis;
    newData[index]["n_lic"] = n_asis;
    newData[index]["porcentaje"] = 0;
  }*/
  //-------------------------------------------
  /*
    "id_mate": 20,
    "id_carre": 4,

   */
  cargar_data=()=>{
    console.log("cargar_data")
    //let id_est = this.props.store.user.id_est;
    /*let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;*/
    let id_asisfe = this.props.params.id;

    let param = { 
      id: id_asisfe,
      //id_peri: id_peri,
    }
    console.log(param)
    axios2.post("asistencia2_get_list", param)
    .then(res => {
        console.log(res.data)
        if(res.data.length>0){ 
            this.setState({dataList: res.data});
        }else{
          this.setState({dataList: [] });
            //NotificationManager.error('No existen datos');
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }

  cargar_form=()=>{
    console.log("cargar_form")
    //let id_est = this.props.store.user.id_est;
    /*let id_mate = this.props.store.materia.id_mate;
    let id_peri = this.props.store.user.id_peri;
    let periodo = this.props.store.user.periodo;*/
    let id_asisfe = this.props.params.id;
    

    let param = { 
      id: id_asisfe,
      //id_peri: id_peri,
    }
    console.log(param)
    axios2.post("asistencia2_get_form", param)
    .then(res => {
        console.log(res.data)
        
        this.setState({ form1 : res.data.form });
        
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  }
  //-----------------------------------------
  // retorna id_mate, nombre, sigla
  guardar_click=()=>{
    console.log("guardar_click");
    console.log("")
    
    
    this.save();
  }
  //-----------------------------------
  tabla_filter=()=>{
    const filteredBooks = [];
    this.state.dataList.forEach(filterValue => {
      filteredBooks.push({"id_asis":filterValue.id_asis, "asis": filterValue.asis} );
    });
    return filteredBooks;
  }
  //-----------------------------------
  save =() =>{
    const user = this.props.store.user;
    const materia = this.props.store.materia;

    let param = { 
      id_asisfe: this.state.id_asisfe,
      tabla:  JSON.stringify( this.tabla_filter() )
    };

    console.log(param);
    this.setState({isloaging: true})
    
    axios2.post("asistencia2_store", param)
    .then(res => {
        console.log(res.data);
        this.setState({isloaging: false})

        if(res.data.exito === 1){ 
            
            NotificationManager.success(res.data.men);         
        }else{
            NotificationManager.error(res.data.men);
            
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
    
  }
  //==========del modal==================================
  config_click=()=>{
    console.log("config_click")
    
    this.modalRef.current.nuevo(); 
  }
  okModal=(id_asis)=>{
    console.log("->"+ id_asis)
    //---marcamos la columna con todos el valor que retorna
    const newData = [...this.state.dataList];

    for (let x = 0; x < newData.length; x++) {
      newData[x]['asis'] = id_asis;
    }
    //newData[index][columnId] = value;
        
    console.log(newData);
    //setData({  data: newData    });
    this.setState({ datalist: newData });
  }
  //---------------------------------
  okModalSorteo=(id_asis)=>{
    console.log("->"+ id_asis)
            
    //this.setState({ datalist: newData });
  }
  sorteo_click=(e)=>{  
    e.preventDefault();
    //le tenemos que pasar la lista de asistentes
    let lista = this.state.dataList.filter((item) => (item.asis==='P' || item.asis==='R') );
    this.modalSorteoRef.current.nuevo(lista);
  }
  //-----------------------
  handleOKInput=(event)=>{
      //-------lo guardamos en la base de datos
      console.log(event)
      //----lo guardamos en la base de datos
      let id_asisfe = this.state.id_asisfe
      let detalle = this.state.form1.detalle

      this.save_deta(id_asisfe , detalle)
    }
    //---------------------------------
    save_deta = (id_asisfe, detalle) => {
      let user = this.props.store.user
      //const materia = this.props.store.materia;
      //let id_tarea = this.props.params.id
      let param = { 
        id_asisfe : id_asisfe,
        detalle: detalle,
      }
      console.log(param)

      this.setState({isLoading: true});
      axios2.post("asistencia2_save_deta", param)
      .then(res => {
          this.setState({isLoading: false});

          if(res.data.exito===1){ 
              //this.setState({data: res.data});
              NotificationManager.success("Existo");
          }else{
              NotificationManager.error("Error: 129");
          }

      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
          
      });
    };
    //--------------------------------------
  
  //============================================
  //----------------------------
  onClickItem=(item)=>{
    console.log(item)
  }
  //---------
  //------------------------------
  render() {
    let materia = this.props.store.materia

    return(
      <div>
        {/* ---   --- */}
        { //JSON.stringify(this.state.form)
        }
        <div className="escritorio center-align p-3">

          <div className="row">
            <div className="col-md-7">
              <h3> Asistencia 2</h3>
              <Button name="btn_save" 
                  className="btn btn-success" 
                  onClick={this.guardar_click } >
                Guardar
              </Button>
              &nbsp;
              <button className="btn btn-defult"
                  onClick={ this.sorteo_click }>
                Sorteo
              </button>
              {/*<!-- -->*/}
                <NuLoading text="Cargando...." show= { this.state.isloaging }/>
              {/*<!-- -->*/}
              <p>
                Sigla: { materia.sigla }<br />
                Materia: { materia.nombre }  <br />
                Grupo: { materia.grupo } <br />
                -----------------<br/>
                Fecha: { this.state.form1.fecha }<br/>
                Detalle: 
                <NuInputEdit 
                            type="text"                           
                            className="form-control" 
                            wrapperStyle={{width:0}}
                            containerStyle= {{ width:190 }}
                            name="detalle" 
                            value={ this.state.form1.detalle }
                            onChange={ this.handleChangeForm1 } 
                            onOkInput={this.handleOKInput }
                            initEdit={true}
                            valtipo='string2'
                            
                        />
                <br/>
                 
                {/*<NuDrop
                  options={this.state.options}
                  onClickItem={ this.onClickItem }
                />*/}
              </p>
            </div>

            <div className="col-md-5">
              <table className="grilla">
                <tbody>
                  <tr>
                    <td className=""><b>Presente</b></td>
                    <td></td>
                    <td className="recuadro" > 
                      <ForSwitch
                          label=""
                          value="P"
                          disabled={true}
                          name='mitris'
                          onChange={(e) => this.handleChangeForm} 
                      />
                    </td>
                  </tr>

                  <tr>
                    <td className=""><b>Retraso</b></td>
                    <td></td>
                    <td className="recuadro" > 
                      <ForSwitch
                          label=""
                          value="R"
                          disabled={true}
                          name='mitris'
                          onChange={(e) => this.handleChangeForm} 
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>Falta</td>
                    <td></td>
                    <td className="recuadro" ></td>
                  </tr>
                  <tr>
                    <td>Licencia</td>
                    <td></td>
                    <td className="recuadro" >
                      <ForSwitch
                          label=""
                          value='L'
                          disabled={true}
                          //onChange={(e) => this.handleCellChange(index,"asis", e.target.value)} 
                      />
                    </td>
                  </tr>
                 
                  {/*<tr>
                    <td>Atrazo</td>
                    <td>A</td>
                    <td className="recuadro" style={{ backgroundColor: '#feff0c' }} >A</td>
                  </tr>*/}
                </tbody>
                </table>
         
            </div>

          </div>

        <table  className="tabla_azul  table-hover" 
                style={{width:'auto'}}>
          <thead>
            <tr>
                <th width="80px">Nro</th>
                <th>Nro. Doc.</th>
                <th>Paterno</th>
                <th>Materno</th>
                <th>Nombres</th>
                <th>Asistencia &nbsp;
                  <img  src={config} alt="" width={16} 
                        style={{ cursor:  'pointer' }} 
                        onClick={ this.config_click }
                        />
                </th>
            </tr>
          </thead>
          <tbody>
              
              {this.state.dataList.map((item,index) => ( 
                  <tr key={index}>
                    <td>{ index+1 }</td>
                    <td>{ item.nro_doc }</td>
                    <td>{ item.ap_pat }</td>
                    <td>{ item.ap_mat }</td>
                    <td>{ item.nombres }</td>
                    <td  >

                      {/*<input type="text" 
                        className='' 
                        style={{width:50, textTransform: 'uppercase', textAlign: 'center' }}
                        onChange={(e) => this.handleCellChange(index,"asis", e.target.value)} 
                        value={item.asis} 
                        />*/}
                      <div style={{display: 'flex'}}>
                        <ForSwitch
                          label=""
                          value={item.asis}
                          onChange={(e) => this.handleCellChange(index,"asis", e.target.value)} 
                        />
                        &nbsp;
                        { item.porc===0?
                          <span style={{color:'red' }} >{ item.porc+"/"+item.cant_col }</span>
                        :
                          <span>{ item.porc+"/"+item.cant_col }</span>
                        }
                      </div>
                    </td>
                    
                    
                  </tr>
              ))}
              
          </tbody>
        </table>
            
        
        </div>
        
        <AsisModal
            ref={this.modalRef}
            okModal={ this.okModal}
            closeModal={ this.closeModal}
            
        />

        <ModalSorteo
          ref={this.modalSorteoRef}
          okModal={this.okModalSorteo}
          
        />

        <NotificationContainer/>
      </div>
    )
  }
}

//------------para que soporte la funcionalidad de parametros
export default withRouterJim(Asistencia2);